import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Device} from './device.model';
import {Component, ViewChild} from '@angular/core';
import {DeviceService} from './device.service';

@Component({
  selector: 'app-device-overview',
  templateUrl: './device-overview.component.html'
})
export class DeviceOverviewComponent extends DatatableViewComponent<Device> {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;
  private filterTimeout;

  public filters: any = {
    UDID: null,
    description: null
  };

  constructor(
    private deviceService: DeviceService,
    private router: UIRouter
  ) {
    super(deviceService);
    this.requestParams.addSortParam({key: 'employee.firstName', value: 'asc'});

    this.fetchData();
  }

  public clearFilters() {
    for(let i = 0; i < Object.keys(this.filters).length; i++) {
      this.filters[Object.keys(this.filters)[i]] = null;
    }

    this.requestParams.removeFilterParams();
    this.fetchData();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.deviceService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public filterData() {
    if(this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }

    this.filterTimeout = setTimeout(() => {
      this.fetchData();
    }, 300);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/device/device-overview.component.ts